<div class="d-flex flex-row align-items-center">
  <lf-icon fillColor="#00C49A" height="24px" name="{{iconName}}" width="24px"></lf-icon>
  <div class="font-12 icon-margin">
    <div class="title_3">{{ title | translate }}</div>
    <p class="text_3">{{ text | translate }}</p>
  </div>
</div>
